import { getLocationAddress } from "../../utils/formatters";

function SelectedLocationBanner({ location, onChangeLocation }) {
  if (!location) {
    return null;
  }

  return (
    <section className="public-selected-location" aria-label="Selected location">
      <div>
        <p className="eyebrow">Ordering from</p>
        <h1>{location.name}</h1>
        <p className="muted-text">{getLocationAddress(location)}</p>
      </div>
      <button className="btn btn-light" onClick={onChangeLocation} type="button">
        Change Location
      </button>
    </section>
  );
}

export default SelectedLocationBanner;